import { render, staticRenderFns } from "./relatedProductModal.vue?vue&type=template&id=20ee0126&scoped=true&"
import script from "./relatedProductModal.vue?vue&type=script&lang=js&"
export * from "./relatedProductModal.vue?vue&type=script&lang=js&"
import style0 from "./relatedProductModal.vue?vue&type=style&index=0&id=20ee0126&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ee0126",
  null
  
)

export default component.exports